var _circle, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 74.5,
    stroke: "black",
    strokeOpacity: 0.3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 145,
    height: 145
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 74.5,
    r: 72.5,
    fill: "#DFDFE9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4586 72L6 128.5L75 160L144 128.5L117.541 72H75H32.4586ZM22 113H52V119C52 123.418 55.5817 127 60 127H89C93.4183 127 97 123.418 97 119V113H127.063L111.349 80H74.9728H37.9803L22 113Z",
    fill: "black",
    fillOpacity: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUwIiBoZWlnaHQ9IjE1MCIgdmlld0JveD0iMCAwIDE1MCAxNTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9Ijc1IiBjeT0iNzUiIHI9Ijc0LjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1vcGFjaXR5PSIwLjMiLz4KPG1hc2sgaWQ9Im1hc2swIiBtYXNrLXR5cGU9ImFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIyIiB5PSIyIiB3aWR0aD0iMTQ1IiBoZWlnaHQ9IjE0NSI+CjxjaXJjbGUgY3g9Ijc0LjUiIGN5PSI3NC41IiByPSI3Mi41IiBmaWxsPSIjREZERkU5Ii8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMCkiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMyLjQ1ODYgNzJMNiAxMjguNUw3NSAxNjBMMTQ0IDEyOC41TDExNy41NDEgNzJINzVIMzIuNDU4NlpNMjIgMTEzSDUyVjExOUM1MiAxMjMuNDE4IDU1LjU4MTcgMTI3IDYwIDEyN0g4OUM5My40MTgzIDEyNyA5NyAxMjMuNDE4IDk3IDExOVYxMTNIMTI3LjA2M0wxMTEuMzQ5IDgwSDc0Ljk3MjhIMzcuOTgwM0wyMiAxMTNaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjMiLz4KPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };